// extracted by mini-css-extract-plugin
export default {"root":"ValidationTextInput_root__CfhOi","errorMessage":"ValidationTextInput_errorMessage__F7DHf"};